export default {
  // 黑名單標籤
  usdtBlocked: "# USDT BLOCKED",
  usdcBlocked: "# USDC BLOCKED",

  // 地址信息
  availableBalance: "地址可用餘額",
  inOutTransactions: "轉入&轉出筆數(USDT)",
  inOutCounterparties: "轉入&轉出對手數(USDT)",
  cumulativeInOutAmount: "累計轉入&轉出數量(USDT)",
  avgInOutAmount: "平均轉入&轉出數量(USDT)",
  creator: "創建者",
  createdAt: "創建於",
  addressNote: "地址備註",
};
